<div *ngIf="!(quantity === 0)" class="customize-selection__options__opt__qty pds-quantity-stepper d-flex">
    <div class="pds-quantity-stepper-container pds-quantity-stepper-container--outlined pds-quantity-stepper-container--size__small d-flex align-items-center"
        role="group">
        <button id="decrement-outlined-small" 
            [attr.aria-label]="getAriaLabel('decrement')"
            class="pds-quantity-stepper-container-button-background pds-quantity-stepper-container-button-background--outlined pds-quantity-stepper-container-button-background--size__small d-flex align-items-center justify-content-center"
            (click)="onQuantityChange(quantity - 1, $event)">
            <span aria-hidden="true"
                class="pds-svg-qty-stepper-decrease-small pds-quantity-stepper-container-button-background--outlined__icon"></span>
        </button>
        <div
            class="pds-quantity-stepper-container-quantity-value pds-quantity-stepper-container-quantity-value--outlined pds-quantity-stepper-container-quantity-value__small d-flex justify-content-center align-items-center"
            [attr.aria-label]="quantityAriaLabel"
            role="status"
            aria-live="polite"
            aria-atomic="true"
        >
            <span id="counter-outlined-small" aria-hidden="true" class="pds-quantity-stepper-container-quantity-value-input-field-text pds-quantity-stepper-container-quantity-value-input-field-text--outlined">
                {{ quantity }}
            </span>
            <span class="sr-only">{{ quantity }} {{ quantity === 1 ? 'unit' : 'units' }} of {{ option?.name }} selected</span>
        </div>
        <button id="increment-outlined-small" [attr.aria-label]="getAriaLabel('increment')"
            class="pds-quantity-stepper-container-button-background pds-quantity-stepper-container-button-background--outlined pds-quantity-stepper-container-button-background--size__small d-flex align-items-center justify-content-center"
            [disabled]="isMaxQuantityReached()"
            (click)="onQuantityChange(quantity + 1, $event)">
            <span aria-hidden="true"
                [class]="isMaxQuantityReached() 
                    ? 'pds-svg-plus-icon-small pds-quantity-stepper-container-button-background--filled__icon__disabled' 
                    : 'pds-svg-plus-icon-small pds-quantity-stepper-container-button-background--outlined__icon'"></span>
        </button>
    </div>

    <!-- Screen reader announcements -->
    <div class="sr-only" aria-live="polite" aria-atomic="true">{{ announcementMessage }}</div>
</div>
